import React from 'react';

const SitsComLogo = ({ size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="32" height="32" rx="8" fill="var(--accent)" />
    <path
      d="M21.5 9.8C19.2 8.2 10.8 8.4 10.8 13.4C10.8 17.2 21.2 16.4 21.2 21C21.2 25.6 11.2 25.4 10.5 23.4"
      stroke="var(--text-inverse)"
      strokeWidth="2.6"
      strokeLinecap="round"
    />
  </svg>
);

export default SitsComLogo;
